import React, { useState, useEffect } from 'react'
import { MWLButton } from 'react-web-white-label'
import './DpsButtonSummarisation.css'
const DpsButton = ({
  borderRadius = 8,
  buttonType = 'success',
  onClick,
  size = 'medium',
  label,
  buttonVariant = 'contained',
  isStartIconEnabled = true,
  startAdronIcon,
  isEndIconEnabled = true,
  endAdronIcon,
  disabled = false,
  className,
  orientation = 'horizontal',
  textTransform = 'none',
  count = 1,
}) => {
  const [responsiveSize, setResponsiveSize] = useState(size)

  useEffect(() => {
    const calculateResponsiveSize = () => {
      const viewportWidth = window.innerWidth
      // Change to small below 1200px, otherwise use the provided size (default medium)
      if (viewportWidth < 1200) {
        setResponsiveSize('small')
      } else {
        setResponsiveSize(size)
      }
    }

    calculateResponsiveSize()
    window.addEventListener('resize', calculateResponsiveSize)
    return () => window.removeEventListener('resize', calculateResponsiveSize)
  }, [size])

  return (
    <div className="StageTwoButtonComponentMainSection">
      <MWLButton
        borderRadius={borderRadius}
        color={buttonType}
        count={count}
        handleClick={onClick}
        size={responsiveSize}
        text={label}
        variant={buttonVariant}
        isStartIconEnabled={isStartIconEnabled}
        startIcon={startAdronIcon}
        isEndIconEnabled={isEndIconEnabled}
        endIcon={endAdronIcon}
        disabled={disabled}
        className={`button btn--${
          className || buttonType
        } dPSButtonComponentSection`}
        orientation={orientation}
        textTransform={textTransform}
      />
    </div>
  )
}

export default DpsButton
